import {
  addOrgIdRequestInterceptor,
  handleResponseStatusInterceptor
} from '@src/api';

import { Api as AtlasApi } from './atlas/api';
import { Api as BeaconApi } from './beacon/api';
import { Api as ClerkApi } from './clerk/api';
import { Api as CourierApi } from './courier/api';
import { Api as DexterApi } from './dexter/api';
import { Api as LensApi } from './lens/api';
import { Api as SeekerApi } from './seeker/api';

const beaconApi = new BeaconApi({
  baseURL: import.meta.env.VITE_BEACON,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

const dexterApi = new DexterApi({
  baseURL: import.meta.env.VITE_DEXTER,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

const clerkApi = new ClerkApi({
  baseURL: import.meta.env.VITE_CLERK,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

const seekerApi = new SeekerApi({
  baseURL: import.meta.env.VITE_SEEKER,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

const courierApi = new CourierApi({
  baseURL: import.meta.env.VITE_COURIER,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

const atlasApi = new AtlasApi({
  baseURL: import.meta.env.VITE_ATLAS,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

const lensApi = new LensApi({
  baseURL: import.meta.env.VITE_LENS,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

beaconApi.instance.interceptors.request.use(
  addOrgIdRequestInterceptor,
  error => {
    return Promise.reject(error);
  }
);

dexterApi.instance.interceptors.request.use(
  addOrgIdRequestInterceptor,
  error => {
    return Promise.reject(error);
  }
);

clerkApi.instance.interceptors.request.use(
  addOrgIdRequestInterceptor,
  error => {
    return Promise.reject(error);
  }
);

seekerApi.instance.interceptors.request.use(
  addOrgIdRequestInterceptor,
  error => {
    return Promise.reject(error);
  }
);

courierApi.instance.interceptors.request.use(
  addOrgIdRequestInterceptor,
  error => {
    return Promise.reject(error);
  }
);

atlasApi.instance.interceptors.request.use(
  addOrgIdRequestInterceptor,
  error => {
    return Promise.reject(error);
  }
);

lensApi.instance.interceptors.request.use(addOrgIdRequestInterceptor, error => {
  return Promise.reject(error);
});

beaconApi.instance.interceptors.response.use(response => {
  return response;
}, handleResponseStatusInterceptor);

dexterApi.instance.interceptors.response.use(response => {
  return response;
}, handleResponseStatusInterceptor);

clerkApi.instance.interceptors.response.use(response => {
  return response;
}, handleResponseStatusInterceptor);

seekerApi.instance.interceptors.response.use(response => {
  return response;
}, handleResponseStatusInterceptor);

courierApi.instance.interceptors.response.use(response => {
  return response;
}, handleResponseStatusInterceptor);

atlasApi.instance.interceptors.response.use(response => {
  return response;
}, handleResponseStatusInterceptor);

lensApi.instance.interceptors.response.use(response => {
  return response;
}, handleResponseStatusInterceptor);

export const apiClient = {
  beacon: beaconApi.v1,
  dexter: dexterApi.v1Alpha1,
  clerkApi: clerkApi.api,
  seekerApi: seekerApi,
  courierApi: courierApi.api,
  atlasApi: atlasApi,
  lensApi: lensApi.api
};
